/* [width, height] in pixels */
export type ImageSize = [number, number];

export type ResponsiveImage = {
  desktop: string;
  mobile: string;
};

export type ResearchExampleImages = {
  avatar: string;
  chart: string;
};

export type CoScientistLandingImages = {
  academiaLogo: string;
  academiaLogoWhite: string;
  howItWorks: {
    optimizedForResearch: ResponsiveImage;
    proactiveSuggestions: ResponsiveImage;
    personalized: ResponsiveImage;
  };
  examples: {
    cancerBiology: ResearchExampleImages;
    laborEconomics: ResearchExampleImages;
    physicalChemistry: ResearchExampleImages;
  };
};

export const SECTION_IDS = {
  howItWorks: 'how-it-works',
  dataPrivacy: 'data-privacy',
  faqs: 'faqs',
} as const;
